module.exports = __webpack_public_path__ + "static/img/ability-shit.2b53eeb7.png";